import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';

import SpogLink from 'components/ui/element/SpogLink';

export class SpogLinkRoute extends Component {

    static propTypes = {
        children: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.node),
            PropTypes.node
        ]).isRequired,
        className: PropTypes.string, // String to set in the class atribute
        disabled:  PropTypes.bool, //if the button is disabled
        external:  PropTypes.bool, //if the href should be an external endpoint
        to:        PropTypes.string, // String to set in href
        onClick:   PropTypes.func // Listener when link was clicked
    };

    static defaultProps = {
        disabled: false,
        external: false
    };

    render() {
        const {
            children,
            className,
            disabled,
            to,
            onClick,
            external,
            history: {location: {pathname}}
        } = this.props;

        return (
            <SpogLink
                pathname={pathname}
                className={className}
                disabled={disabled}
                to={to}
                onClick={onClick}
                external={external}
            >
                {children}
            </SpogLink>
        );
    }
}

export default withRouter(SpogLinkRoute);



// WEBPACK FOOTER //
// ./src/router-with/ui/SpogLinkRoute.js